import { render, staticRenderFns } from "./thirdsecond.vue?vue&type=template&id=8f704230&"
import script from "./thirdsecond.vue?vue&type=script&lang=js&"
export * from "./thirdsecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f704230')) {
      api.createRecord('8f704230', component.options)
    } else {
      api.reload('8f704230', component.options)
    }
    module.hot.accept("./thirdsecond.vue?vue&type=template&id=8f704230&", function () {
      api.rerender('8f704230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/third/thirdsecond.vue"
export default component.exports